import image1 from '../pic/hadanti.jpg'
import image2 from '../pic/hayla.png'
import image3 from '../pic/cleano.png'
import image4 from '../pic/nefertiti.jpg'

  const TestimonialApi = [
    {
      id: 1,
      image: image1,
      
      name: "Hadanti",
      
      post: "Website application",
      
      desc: "Social Media Marketing",
    },
    {
      id: 2,
      image: image2,
     
      name: "Hayla-tn",
     
      post: "Oline Store",
      
      desc: "Creation of online store, graphic design and management of social media marketing.",
    },
    {
      id: 3,
      image: image3,
     
      name: "Cleanobox",
      
      post: "E-COMMERCE Website",
      
      desc: "Online store creation and social media marketing management.",
    },
    {
      id: 4,
      image: image4,
     
      name: "Nefertiti",
      
      post: "Cosmetics Company",
      
      desc: "Graphique desgin and social media marketing.",
    },
    
  ]
  
  export default TestimonialApi